import React, { Fragment, useMemo } from 'react';
import { Box, Heading, List, ListItem, Text } from '@chakra-ui/react';
import { parseProfileMarkup } from '../../utils/profileMarkup';

const renderRuns = (runs) =>
  runs.map((run, index) => {
    let node = run.text;
    if (run.italic) {
      node = <em>{node}</em>;
    }
    if (run.bold) {
      node = <strong>{node}</strong>;
    }
    return <Fragment key={index}>{node}</Fragment>;
  });

const PRINT_KEEP_TOGETHER = { '@media print': { breakInside: 'avoid' } };

// Renders profile text (see utils/profileMarkup.js) as React elements; it never injects
// HTML. Headings render one level below the surrounding section title (h3) and size
// relative to the body text. Typography props (fontSize, lineHeight, color, ...) are
// applied to the wrapper; headingProps style the in-text headings.
const FormattedText = ({ text, headingProps, ...typography }) => {
  const blocks = useMemo(() => parseProfileMarkup(text), [text]);
  if (blocks.length === 0) {
    return null;
  }

  return (
    <Box {...typography} sx={{ '& > :not(:last-child)': { mb: 3 } }}>
      {blocks.map((block, index) => {
        if (block.type === 'heading') {
          return (
            <Heading
              key={index}
              as="h3"
              fontSize="1.25em"
              fontWeight="600"
              lineHeight="1.3"
              color="inherit"
              sx={PRINT_KEEP_TOGETHER}
              {...headingProps}
            >
              {renderRuns(block.runs)}
            </Heading>
          );
        }
        if (block.type === 'bulletList') {
          return (
            <List key={index} as="ul" styleType="disc" spacing={1} pl={5}>
              {block.items.map((runs, itemIndex) => (
                <ListItem key={itemIndex} sx={PRINT_KEEP_TOGETHER}>
                  {renderRuns(runs)}
                </ListItem>
              ))}
            </List>
          );
        }
        return (
          <Text key={index}>
            {block.lines.map((runs, lineIndex) => (
              <Fragment key={lineIndex}>
                {lineIndex > 0 && <br />}
                {renderRuns(runs)}
              </Fragment>
            ))}
          </Text>
        );
      })}
    </Box>
  );
};

export default FormattedText;
